'use strict';

angular.module('programme')

.directive('column', function ()
{
    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'modules/programme/editor-components/column/column.html',
        controller: 'ColumnCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('ColumnCtrl', function ($scope)
{
    $scope.data.list = $scope.data.list || [];

    if ($scope.data.centered === undefined) {
        $scope.data.centered = false;
    }

    this.selected = null;
    this.defaultColumn = {
        xs: 12,
        sm: 12,
        md: 6,
        lg: 6,
        components: [],
    };


    this.$onInit = function ()
    {
        if (!$scope.data.list.length) {
            this.addColumn();
        }
    };

    this.addColumn = function ()
    {
        var length = $scope.data.list.length;
        if (length) {
            $scope.data.list.push(angular.copy($scope.data.list[length - 1]));
        } else {
            $scope.data.list.push(angular.copy(this.defaultColumn));
        }
    };

    this.selectColumn = function (column)
    {
        this.selected = column;
    };

    this.destroyColumn = function (column)
    {
        var index = $scope.data.list.indexOf(column);
        if (index === -1) {
            return;
        }

        $scope.data.list.splice(index, 1);
        this.selectColumn($scope.data.list[index]);
    };

    this.selectRelative = function (modifier)
    {
        if (!this.selected) {
            this.selected = $scope.data.list[0];
            return;
        }

        var index = $scope.data.list.indexOf(this.selected);
        if (index === -1) {
            this.selected = null;
            return;
        }

        index += modifier;
        index = index % $scope.data.list.length;
        if (index < 0) {
            index += $scope.data.list.length;
        }

        this.selected = $scope.data.list[index];
    };

    $scope.$on('component:focus', function ($event)
    {
        if ($event.targetScope.item) {
            this.selectColumn($event.targetScope.item);
        }
    }.bind(this));

    $scope.getCollClass = function(column)
    {
        var cl = {
            active: this.selected === column,
            column: true,
        };

        cl['col-xs-' + column.xs] = true;
        cl['col-sm-' + column.sm] = true;
        cl['col-md-' + column.md] = true;
        cl['col-lg-' + column.lg] = true;

        if (!$scope.data.centered || $scope.data.list.length !== 1) {
            return cl;
        }

        function getColOffset(val)
        {
            return Math.ceil((12 - val) / 2);
        }

        cl['col-xs-offset-' + getColOffset(column.xs)] = true;
        cl['col-sm-offset-' + getColOffset(column.sm)] = true;
        cl['col-md-offset-' + getColOffset(column.md)] = true;
        cl['col-lg-offset-' + getColOffset(column.lg)] = true;

        return cl;
    };

    this.$onInit();
});
